import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import qs from 'qs';
import _get from 'lodash/get';
import styles from './index.module.scss';

import { useAuthGuard, useMutation } from 'utils/hooks';
import { logout } from 'utils/services';
import { getCredentialSearch } from 'utils/credentialUrl';
import { ConfirmSessionSwitch } from 'components';
import { getActiveSessionStoreName } from 'utils/DICTIONARY';
import { setAccessRefreshToken } from 'utils/services/auth';
import { IS_ALL_SSR } from 'dictionary';
import SSRLoggedOut from 'containers/SSRLoggedOut';
import ssImage from 'assets/ss-icons/shipstation-icon.png';

export default function SellerSignIn() {
  const { search } = useLocation();
  const { replace } = useHistory();
  const [hasError, setHasError] = useState(false);

  // An existing session must not be replaced without the user's consent,
  // except in the all-SSR build, which is embedded in ShipStation and where the
  // switch is part of the flow
  const [currentStore] = useState(getActiveSessionStoreName);
  const [isConfirmed, setIsConfirmed] = useState(!currentStore || IS_ALL_SSR);

  const { onAuthenticated } = useAuthGuard();

  const {
    redirect_path: redirectPath = '/',
    ...queryData
  } = qs.parse(getCredentialSearch(search), { ignoreQueryPrefix: true });

  // Always redirect to configure page when REACT_APP_IS_ALL_SSR is true
  const finalRedirectPath = IS_ALL_SSR ? '/configure' : redirectPath;

  const { mutate: signIn } = useMutation('auth.sellerSignIn', 'POST', {
    payload: { ...(queryData || {}) },
    errorMessage: "We couldn't log you in.",
    onSuccess: res => {
      onAuthenticated(_get(res, 'data', {}), finalRedirectPath);
      setAccessRefreshToken(_get(res, 'refresh', ''));
    },
    onError: () => {
      if (IS_ALL_SSR) {
        setHasError(true);
      } else {
        replace('/login');
      }
    }
  });

  useEffect(() => {
    if (isConfirmed) {
      logout(() => signIn());
    }
  }, [isConfirmed, signIn]);

  if (!isConfirmed) {
    return (
      <ConfirmSessionSwitch
        currentStore={currentStore}
        onConfirm={() => setIsConfirmed(true)}
        onCancel={() => replace('/')}
      />
    );
  }

  if (hasError) {
    return <SSRLoggedOut />;
  }

  return (
    <div className={styles.container}>
      <img className={styles.ssImage} src={ssImage} alt="not found" />
    </div>
  );
}
